// columnsConfig.js

import { Checkbox,Input} from 'antd';
import { Select } from 'antd';
import { FilterOutlined,EditOutlined,CheckOutlined,CloseOutlined } from "@ant-design/icons";
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { AiOutlineLink } from 'react-icons/ai';
import CustomFilter from './CustomFilter';
import moment from 'moment';
import { Button } from 'antd';

import { DDMMMYYYY_FORMAT } from "../constants";
import labels from "./labels.json";
import { Tooltip } from 'antd';


 
export const pageSize = 10;
const basePath = sessionStorage.getItem('APP_BASE_PATH')
// Columns configuration for CartViewPage
export const cartViewPageColumns = [
  {
    title: "Row #",
    key: "rowNumber",
    render: (text, record, index) => index + 1,
  },
  {
    title: "UID",
    dataIndex: "uid",
    key: "uid",
    width: 100,
  },
  {
    title: "Name",
    dataIndex: "username",
    key: "username",
    render: (text, record) => `${record.firstName} ${record.lastName}`,
  },
  {
    title: "Email Id",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "BGV",
    dataIndex: "bgv",
    key: "bgv",
    render: () => <Checkbox checked className="green-checkbox" disabled />,
  },
  {
    title: "Drug Test",
    dataIndex: "drugtest",
    key: "drugtest",
    render: () => <Checkbox checked className="green-checkbox" disabled />,
  },
  {
    title: "Authorization Letter",
    dataIndex: "authorizationletter",
    key: "authorizationletter",
    render: () => <Checkbox checked className="green-checkbox" disabled />,
  },
  {
    title: "Skill Repository",
    dataIndex: "skillrepository",
    key: "skillrepository",
    render: () => <Checkbox checked className="green-checkbox" disabled />,
  },
  {
    title: "VDI Compliance",
    dataIndex: "vdicompliance",
    key: "vdicompliance",
    render: () => <Checkbox checked className="green-checkbox" disabled />,
  },
];

// Columns configuration for SearchPage
export const searchPageColumns = (gridData = []) => [
  {
    title: "UID",
    dataIndex: "uid",
    key: "uid",
    width: 90,
    filters: [...new Set(gridData.map((item) => item.uid))].map((value) => ({
      text: value,
      value: value,
    })),
    onFilter: (value, record) => record.uid.includes(value),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <CustomFilter
        filters={[...new Set(gridData.map((item) => item.uid))].map(
          (value) => ({
            text: value,
            value: value,
          })
        )}
        onFilter={(selectedFilters) => {
          setSelectedKeys(selectedFilters);
        }}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{ color: filtered ? "var(--color-secondary)" : "white" }}
      />
    ),
    render: (text) => (
      <a
        href={`${basePath}/ViewPage/${text}`}
        rel="noopener noreferrer"
        style={{ textDecoration: "underline", color: "blue" }}
      >
        {text}
      </a>
    ),
  },
  {
    title: "First Name",
    dataIndex: "firstName",
    key: "firstName",
    width: 120,
    filters: [...new Set(gridData.map((item) => item.firstname))].map(
      (value) => ({
        text: value,
        value: value,
      })
    ),
    onFilter: (value, record) => record.firstName.includes(value),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <CustomFilter
        filters={[...new Set(gridData.map((item) => item.firstName))].map(
          (value) => ({
            text: value,
            value: value,
          })
        )}
        onFilter={(selectedFilters) => {
          setSelectedKeys(selectedFilters);
        }}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{ color: filtered ? "var(--color-secondary)" : "white" }}
      />
    ),
  },
  {
    title: "Last Name",
    dataIndex: "lastName",
    key: "lastName",
    width: 120,
    filters: [...new Set(gridData.map((item) => item.lastname))].map(
      (value) => ({
        text: value,
        value: value,
      })
    ),
    onFilter: (value, record) => record.lastName.includes(value),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <CustomFilter
        filters={[...new Set(gridData.map((item) => item.lastName))].map(
          (value) => ({
            text: value,
            value: value,
          })
        )}
        onFilter={(selectedFilters) => {
          setSelectedKeys(selectedFilters);
        }}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{ color: filtered ? "var(--color-secondary)" : "white" }}
      />
    ),
  },
  {
    title: "Email Id",
    dataIndex: "email",
    key: "email",
    width: 150,
    filters: [...new Set(gridData.map((item) => item.email))].map((value) => ({
      text: value,
      value: value,
    })),
    onFilter: (value, record) => record.email.includes(value),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <CustomFilter
        filters={[...new Set(gridData.map((item) => item.email))].map(
          (value) => ({
            text: value,
            value: value,
          })
        )}
        onFilter={(selectedFilters) => {
          setSelectedKeys(selectedFilters);
        }}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{ color: filtered ? "var(--color-secondary)" : "white" }}
      />
    ),
  },
  {
    title: "Phone No",
    dataIndex: "phoneNo",
    key: "phoneNo",
    width: 120,
    render: (text) => (
      <span style={{ 
        fontSize: text === "-" ? "30px" : "inherit", 
        display: "block", 
        textAlign: "center" 
      }}>
        {text}
      </span>
    ),
    
  },
  {
    title: "Location",
    dataIndex: "location",
    key: "location",
    width: 100,
    filters: [...new Set(gridData.map((item) => item.location))].map(
      (value) => ({
        text: value,
        value: value,
      })
    ),
    onFilter: (value, record) => record.location.includes(value),
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <CustomFilter
        filters={[...new Set(gridData.map((item) => item.location))].map(
          (value) => ({
            text: value,
            value: value,
          })
        )}
        onFilter={(selectedFilters) => {
          setSelectedKeys(selectedFilters);
        }}
        clearFilters={clearFilters}
        confirm={confirm}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{ color: filtered ? "var(--color-secondary)" : "white" }}
      />
    ),
  },
  {
    title: "Date Of Birth",
    dataIndex: "dateOfBirth", // ✅ Fixed casing to match API
    key: "dateofbirth",
    width: 120,
    render: (text) => (
      <span style={{ 
        fontSize: text === "-" ? "30px" : "inherit", 
        display: "block", 
        textAlign: "center" 
      }}>
        {text}
      </span>
    ),
    
  },
  {
    title: "Date Of Joining",
    dataIndex: "dateOfJoining", // ✅ Fixed casing to match API
    key: "dateofjoining",
    width: 120,
    render: (text) => (text ? text : "N/A"),
  },
];

export const activityPageColumns = (handleEditClick) => [
    {
      title: 'Activity Name',
      dataIndex: 'activityName',
      key: 'activityName',
    },
    {
      title: 'Activity Date',
      key: 'activityDate',
      render: (_, record) => {
        const startDate = moment(record.activityStartDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
        const endDate = moment(record.activityEndDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
        return `${startDate} - ${endDate}`;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <EditOutlined onClick={() => handleEditClick(record)} style={{ cursor: 'pointer', color: 'green' }} />
      ),
    },
  ];

export const userJobSearchColumns = (handleEditClick) => [{
  title: 'Job Title',
  dataIndex: 'jobTitle',
  key: 'jobTitle',
  width: 150
},
{
  title: 'Primary Skill',
  dataIndex: 'primarySkill',
  key: 'primarySkill',
  width: 150
},
{
  title: 'Secondary Skill',
  dataIndex: 'secondarySkill',
  key: 'secondarySkill',
  width: 150
},
{
  title: 'Location',
  dataIndex: 'location',
  key: 'location',
  width: 150
},
{
  title: 'Project Name',
  dataIndex: 'projectName',
  key: 'projectName',
  width: 150
},
{
  title: 'POC Email ID',
  dataIndex: 'pocEmailId',
  key: 'pocEmailId',
  width: 200
},
{
  title: 'Experience',
  dataIndex: 'experience',
  key: 'experience',
  width: 150
},
{
  title: 'Description',
  dataIndex: 'description',
  key: 'description',
  width: 300
}];

export const trainingCoursesColumns = (setModalVisible, setSelectedId) => [
   /*  {
      title: 'Training Name',
      dataIndex: 'trainingName',
      key: 'trainingName',
      width: 150,
      ...getColumnSearchProps('trainingName'),
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => {
            setSelectedId(record.key);
            setModalVisible(true);
          }}
        >
          {text}
        </span>
      ),
    },
    */
    {
      title: labels.trainingGridHeaderName,
      dataIndex: 'trainingName',
      key: 'trainingName',

      style:"px-1 py-1 text-left bg-white font-bold",
      ...getColumnSearchProps('trainingName'),
    },
  {
    title: labels.trainingGridHeaderDescription,
    dataIndex: 'description',
    key: 'description',
    style:"px-1 py-1 text-left bg-white font-bold",
  },
  {
    title: labels.trainingGridHeaderStartDate,
    dataIndex: 'trainingStartDate',
    key: 'trainingStartDate',
    style:"px-1 py-1 text-left bg-white font-bold",
    //...getColumnSearchProps('trainingStartDate'),
    render:(text) => moment(text).format(DDMMMYYYY_FORMAT),
  },
  {
    title: labels.trainingGridHeaderEndDate,
    dataIndex: 'trainingEndDate',
    key: 'trainingEndDate',
    style:"px-1 py-1 text-left bg-white font-bold",
    render:(text) => moment(text).format(DDMMMYYYY_FORMAT),
  
  },
  {
    title: labels.trainingGridHeaderTime,
    dataIndex: 'time',
    style:"px14 py-1 text-left bg-white font-bold",
    key: 'time',
  },
  {
    title: labels.trainingGridemailId,
    dataIndex: 'emailId',
    style:"px-1 py-1 text-left bg-white font-bold",
    key: 'emailId',
    
  },
  {
    title: labels.trainingGridPrerequisties,
    dataIndex: 'prerequisites',
    key: 'prerequisites',
    style:"px-1 py-0 text-left bg-white font-bold",
   // ...getColumnSearchProps('prerequisites'),
  },
  {
    title: labels.trainingGridMode,
    dataIndex: 'trainingMode',
    style:"px-4 py-2 text-left bg-white font-bold",
    key: 'trainingMode',
    ...getColumnSearchPropsForMode('trainingMode'),
    },
  {
    title: labels.trainingGridCertificate,
    dataIndex: 'certificate',
    key: 'certificate',
    style:"px-4 py-2 text-left bg-white font-bold",
    
  },
  {
    title: labels.trainingGridIsInternal,
    dataIndex: 'trainingType',
    key: 'trainingType',
    style:"px-4 py-2 text-left bg-white font-bold",
  },
  
{
    title: labels.trainingGridEnrollmentLink,
    dataIndex: 'trainingLink',
    key: 'trainingLink',
    render: (text) => (
      text ? (
        <Tooltip title="Course Link">
          <a href={text} target="_blank" rel="noopener noreferrer">
            Click here
          </a>
        </Tooltip>
      ) : ''
    ),
  }
  
];

// formatting TrainingData
export const formatTrainingData = (data) => {
  const formatTime = ([hours, minutes]) => {
    // Pad single digits with leading zero
    const h = hours.toString().padStart(2, '0');
    const m = minutes.toString().padStart(2, '0');
    return `${h}:${m}`;
  };

  return data.map(item => ({
    key: item.id,
    trainingName: item.trainingName,
    description: item.description,
    trainingStartDate: item.trainingStartDate,
    trainingEndDate: item.trainingEndDate,
    time: `${formatTime(item.startTime)} - ${formatTime(item.endTime)}`, // Display combined time
    emailId: item.emailId,
    prerequisites: item.prerequisites,
    trainingMode: item.trainingMode,
    certificate: item.certificate,
    trainingType: item.trainingType,
    trainingLink: item.trainingLink
  }));
};

const getColumnSearchProps = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => confirm()}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <FilterOutlined style={{ color: filtered ? "var(--color-secondary)" : "white" }} />
  )
  ,
  onFilter: (value, record) =>
    record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : '',
});


const getColumnSearchPropsForMode = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Select
        placeholder={`Select ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={value => setSelectedKeys(value ? [value] : [])}
        style={{ width: 200, marginBottom: 8, display: 'block' }}
      >
        <Select.Option value="Virtual">Virtual</Select.Option>
        <Select.Option value="Office">Office</Select.Option>
      </Select>
      <Button
        type="primary"
        onClick={() => confirm()}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <FilterOutlined style={{ color: filtered ? "var(--color-secondary)" : "white" }} />
  )
  ,
  onFilter: (value, record) =>
    record[dataIndex]
      ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
      : '',
});

export const getRowClassName = (record, index) => {
  return index % 2 === 0 ? "bg-white" : "bg-gray-50";
};

export const complianceTableColumns = [
  {
    title: "Employee ID",
    dataIndex: "employeeId",
    key: "employeeId",
    align: "left",
    width: 120
  },
  {
    title: "Employee Name",
    dataIndex: "employeeName",
    key: "employeeName",
    align: "left",
    width: 150
  },
  {
    title: "VDI Submission Date",
    dataIndex: "vdiSubmissionDate",
    key: "vdiSubmissionDate",
    align: "left",
    width: 150,
    render: (_, record) => {
      const submissionDate = record.vdiSubmissionDate && moment(record.vdiSubmissionDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
      return submissionDate;
    },
  },
  {
    title: "Skill Submission Date",
    dataIndex: "skillRepositorySubmissionDate",
    key: "skillRepositorySubmissionDate",
    align: "left",
    width: 150,
    render: (_, record) => {
      const submissionDate = record.skillRepositorySubmissionDate && moment(record.skillRepositorySubmissionDate, 'DD-MM-YYYY').format('DD-MM-YYYY');
      return submissionDate;
    },
  },
  {
    title: "Skill Repository",
    dataIndex: "skillRepository",
    key: "skillRepository",
    align: "center",
    width: 120,
    render: (text) => {
      if (text !== undefined) {
        return text ? (
          <CheckOutlined style={{ color: "green" }} />
        ) : (
          <CloseOutlined style={{ color: "red" }} />
        );
      }
      return null;
    },
  },
  {
    title: "VDI Compliance",
    dataIndex: "vdi",
    key: "vdi",
    align: "center",
    width: 120,
    render: (text) => {
      if (text !== undefined) {
        return text ? (
          <CheckOutlined style={{ color: "green" }} />
        ) : (
          <CloseOutlined style={{ color: "red" }} />
        );
      }
      return null;
    },
  },
];
